import React from 'react'
import {INavNotification} from '@api/user/account/notification/getNotification'
import {useTranslation} from '@lib/intl/useTranslations'
import {useLoginStore} from '@store/LoginStore'
import useNavigation from '@hook/useNavigation'
import NotificationItemLayout from '@feature/account/components/notifications/NotificationListItem/layout/NotificationItemLayout'

interface INotificationItem extends INavNotification {}

const BotError6003NotificationItem = (props: INotificationItem) => {
    const t = useTranslation()
    const {data} = props
    const id = useLoginStore(state => state.id)
    const {goUserCopyfolio} = useNavigation()

    return (
        <NotificationItemLayout
            {...props}
            text={t(`globalNotification.NotificationItem.bot.error.6003`, {
                leader_name: data?.leader_name ?? '',
            })}
            onClick={() => goUserCopyfolio(id)}
        />
    )
}

export default BotError6003NotificationItem
